import React, { FC } from "react";

type UpdateWaitlistCheckboxProps = {
  onChange: () => void;
  checked: boolean;
  disabled: boolean;
  label: string;
};

export const UpdateWaitlistCheckbox: FC<UpdateWaitlistCheckboxProps> = ({
  onChange,
  checked,
  disabled,
  label,
}) => {
  return (
    <div className="form-check mb-1">
      <label className="form-check-label">
        <input
          type={"checkbox"}
          className="form-check-input form-check-input--light"
          disabled={disabled}
          checked={checked}
          onChange={onChange}
        />
        <span>{label}</span>
      </label>
    </div>
  );
};
